import {Pipe, PipeTransform} from '@angular/core';
import {CodebookService} from "@services";
import {Country} from "@model";

@Pipe({
  name: 'country', pure: true,
  standalone: false
})
export class CountryPipe implements PipeTransform {

  constructor(private codebookService: CodebookService) {}

  transform(id: any, format: 'name' | 'shortCode' | 'isoCode' | 'iocCode' | 'callCode' = 'name'): string | undefined {
    if (id === undefined || id === null) return undefined;
    const countries = this.codebookService.countries.snapshot;
    if (!countries?.length) {
      return undefined;
    }

    const numericId = Number(id);
    const country: Country | undefined = !Number.isNaN(numericId)
        ? countries.find((c: Country) => c.id === numericId)
        : this.findByCode(countries, id);

    if (!country) {
      return undefined;
    }

    switch (format) {
      case 'name': return country.name;
      case 'shortCode': return country.shortCode?.toUpperCase();
      case 'isoCode': return country.isoCode?.toUpperCase();
      case 'iocCode': return country.iocCode?.toUpperCase();
      case 'callCode': return country.callCode?.toUpperCase();
      default: return undefined;
    }
  }

  /// Results carry the country as a code string (e.g. "CRO") rather than a codebook id, so fall
  /// back to matching any of the code columns before giving up.
  private findByCode(countries: Country[], value: any): Country | undefined {
    if (typeof value !== 'string') return undefined;
    const code: string = value.trim().toUpperCase();
    if (!code) return undefined;

    return countries.find((c: Country) => c.iocCode?.toUpperCase() === code.toUpperCase())
        ?? countries.find((c: Country) => c.shortCode?.toUpperCase() === code.toUpperCase())
        ?? countries.find((c: Country) => c.isoCode?.toUpperCase() === code.toUpperCase());
  }
}